import {
  Button,
  Checkbox,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Option,
  Select,
  Switch,
  Textarea,
  Typography
} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import dict from "../../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../../style/datePicker.css"
import {getFieldBranches} from "../../../services/branch/branch";
import SelectInput from "../../system/select";
import DateField from "../../system/dateField";
import Validator from "../../../helper/validator/Validator";
import {ValidatorProvider} from "../../../helper/validator/ValidatorContext";
import {DiscountContext} from "../../../context/discount_context";
import {getPersonsNameAndFamily} from "../../../services/profile/profile";
import {getAgentsList} from "../../../services/agent/agent";
import {submitDiscount, updateDiscount} from "../../../services/discount/discount";
import {includes} from "lodash/collection";
import {PersianNumberInput} from "../../system/persianNumberInput";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import {Toaster} from "../../../helper/Toaster";

export function DiscountForm() {

  const {discount, setDiscount, modalOpen, setModalOpen, setLastDataRefresh} = useContext(DiscountContext);

  const handleOpen = () => setModalOpen(!modalOpen);

  const [id, setId] = useState(null)
  const [percentage, setPercentage] = useState(null)
  const [maxValue, setMaxValue] = useState(null)
  const [maxValueUsage, setMaxValueUsage] = useState(null)
  const [expirationDate, setExpirationDate] = useState("")
  const [status, setStatus] = useState(true)
  const [isChecked, setIsChecked] = useState(false);
  const [branchIds, setBranchIds] = useState([])
  const [allBranches, setAllBranches] = useState(true)
  const [personIds, setPersonIds] = useState([])
  const [allPersons, setAllPersons] = useState(true)
  const [agentIds, setAgentIds] = useState([])
  const [allAgents, setAllAgents] = useState(true);

  const [oneTime, setOneTime] = useState(false);

  useEffect(() => {
    setId(discount?.id ?? null)
    setBranchIds(discount?.branch_id ?? null)
    setPercentage(discount?.percentage ?? null)
    setMaxValue(discount?.max_value ?? null)
    setMaxValueUsage(discount?.max_value_usage ?? null)
    setExpirationDate(discount?.expiration_date ?? "")
    if (discount?.id) {
      setAllPersons(includes(discount?.person_ids, 0))
      setPersonIds(discount?.person_ids ?? null)
      setAllBranches(includes(discount?.branch_ids, 0))
      setBranchIds(discount?.branch_ids ?? null)
      setAllAgents(includes(discount?.agent_ids, 0))
      setAgentIds(discount?.agent_ids ?? null)
    } else {
      setAllPersons(true)
      setAllBranches(true)
      setAllAgents(true)
    }
  }, [discount]);

  useEffect(() => {
    setDiscount(discount => ({
      ...discount,
      one_time: oneTime,
    }))
  }, [oneTime]);

  useEffect(() => {
    setDiscount(discount => ({
      ...discount,
      percentage: percentage,
    }))
  }, [percentage]);

  useEffect(() => {
    setDiscount(discount => ({
      ...discount,
      max_value: maxValue,
    }))
  }, [maxValue]);

  useEffect(() => {
    setDiscount(discount => ({
      ...discount,
      max_value_usage: maxValueUsage,
    }))
  }, [maxValueUsage]);

  useEffect(() => {
    setDiscount(discount => ({
      ...discount,
      expiration_date: expirationDate,
    }))
  }, [expirationDate]);

  const save = async () => {
    const data = {
      branch_ids: allBranches ? [] : branchIds,
      person_ids: allPersons ? [] : personIds,
      agent_ids: allAgents ? [] : agentIds,
      code: discount.code,
      percentage: discount.percentage,
      max_value: discount.max_value,
      max_value_usage: discount.max_value_usage,
      type: discount.type,
      expiration_date: discount.expiration_date,
      description: discount.description,
      one_time: discount.one_time,
      status: discount.status ? "enable" : "disable",
    };
    // const res = checkAll();
    // if (!res) {
    //   Toaster.failure(null,
    //     <Typography variant="small">
    //       مقادیر الزامی را بر اساس راهنما تکمیل کنید
    //     </Typography>);
    //   return
    // }
    let result;

    if (!id) {
      result = await submitDiscount(data);
    } else {
      data.id = id
      result = await updateDiscount(data);
    }

    if (result.status === 200) {
      setDiscount(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <ValidatorProvider>
      <>
        <Dialog open={modalOpen} handler={handleOpen}
                animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            {!discount?.id ?
              <Typography>ایجاد کد تخفیف</Typography>
              :
              <Typography>
                {`ویرایش کد تخفیف ${discount.code}`}
              </Typography>
            }
          </DialogHeader>
          <DialogBody className="flex flex-col gap-4 overflow-y-scroll max-h-[600px]">

            {!discount?.id ?
              <div className="mb-4">
                <Input variant="standard"
                       value={discount?.code}
                       label={Dict('discount_code')}
                       placeholder={Dict('discount_code')}
                       onChange={(e) => {
                         setDiscount(discount => ({
                           ...discount,
                           code: e.target.value,
                         }))
                       }}
                />
                <Validator isChecked={isChecked} state={discount?.code} rules="required"/>
                <Validator isChecked={isChecked} state={discount?.code} rules="alphanumeric"/>
              </div>
              :
              <div className="flex flex-row mb-4">
                <Typography className="ml-4">
                  {`${dict("discount_code")}:`}
                </Typography>
                <Typography color="blue-gray">
                  {discount.code}
                </Typography>
              </div>
            }

            {!discount?.id ?
              <div className="mb-4">
                <PersianNumberInput label={Dict('discount_percentage')} extension="%" value={percentage}
                                    setValue={setPercentage}/>
                <Validator isChecked={isChecked} state={percentage} rules="required"/>
                <Validator isChecked={isChecked} state={percentage} rules="num"/>
              </div>
              :
              <div className="flex flex-row mb-4">
                <Typography className="ml-4">
                  {`${dict("discount_percentage")}:`}
                </Typography>
                <Typography color="blue-gray">
                  {discount.percentage}
                </Typography>
              </div>
            }

            {!discount?.id ?
              <div className="mb-4">
                <Select
                  variant="static"
                  label="نوع خدمت"
                  value={discount?.type}
                  onChange={(val) => setDiscount(d => ({...d, type: val}))}
                >
                  <Option value="public" className="text-right">عمومی</Option>
                  <Option value="consultation" className="text-right">مشاوره</Option>
                  <Option value="service" className="text-right">خدمات</Option>
                </Select>
              </div>
              :
              <div className="flex flex-row mb-4">
                <Typography className="ml-4">
                  {`${dict("نوع خدمت")}:`}
                </Typography>
                <Typography color="blue-gray">
                  {`${discount?.type === "public" ? "عمومی" : discount?.type === "consultation" ? "مشاوره" : "خدمات"}`}
                </Typography>
              </div>
            }

            {!discount?.id ?
              <div className="mb-4">
                <PersianNumberInput label={Dict('discount_value')} extension="ریال" value={maxValue}
                                    setValue={setMaxValue}/>
                <Validator isChecked={isChecked} state={maxValue} rules="required"/>
                <Validator isChecked={isChecked} state={maxValue} rules="num"/>
              </div>
              :
              <div className="flex flex-row mb-4">
                <Typography className="ml-4">
                  {`${dict("discount_value")}:`}
                </Typography>
                <Typography color="blue-gray">
                  {`${persianNumberFormat(discount.max_value, true)} ریال`}
                </Typography>
              </div>
            }

            <div className="mb-4">
              <PersianNumberInput label={Dict('max_discount_value')} extension="ریال" value={maxValueUsage}
                                  setValue={setMaxValueUsage}/>
              <Validator isChecked={isChecked} state={maxValueUsage} rules="required"/>
              <Validator isChecked={isChecked} state={maxValueUsage} rules="num"/>
            </div>

            <div className="flex w-full mb-4">
              <DateField
                className="my-4 mx-4 w-full"
                date={expirationDate}
                setDate={setExpirationDate}
                label={Dict("expiration_date")}
              />
            </div>

            <div className="mb-4">
              <Textarea variant="standard"
                        value={discount?.description}
                        label="توضیحات"
                        placeholder="توضیحات"
                        onChange={(e) => {
                          setDiscount(discount => ({
                            ...discount,
                            description: e.target.value,
                          }))
                        }}
              />
              {discount?.description?.length > 0 &&
                <Validator isChecked={isChecked} state={discount.description} rules="alphanumeric"/>
              }
            </div>

            <Checkbox
              checked={oneTime}
              onChange={() => {
                if (!discount?.id) {
                  setOneTime(!oneTime)
                } else {
                  Toaster.failure(null,
                    "امکان تغییر این گزینه وجود ندارد.")
                }
              }
              }
              label={
                <div>
                  <Typography color="blue-gray" className="font-medium">
                    یک بار مصرف
                  </Typography>
                  <Typography variant="small" color="gray" className="font-normal">
                    با فعال کردن این گزینه، هر کاربر تنها یک بار امکان استفاده از کد تخفیف را دارد.
                  </Typography>
                </div>
              }
              containerProps={{
                className: "-mt-5",
              }}

            />

            <Checkbox
              checked={allBranches}
              onChange={() => {
                if (!discount?.id) {
                  setAllBranches(!allBranches)
                } else {
                  Toaster.failure(null,
                    "امکان تغییر این گزینه وجود ندارد.")
                }
              }
              }
              label={
                <div>
                  <Typography color="blue-gray" className="font-medium">
                    همه گرایش‌ها
                  </Typography>
                  <Typography variant="small" color="gray" className="font-normal">
                    با غیرفعال کردن این گزینه، می‌توانید گرایش های مورد نظر را محدود کنید.
                  </Typography>
                </div>
              }
              containerProps={{
                className: "-mt-5",
              }}

            />

            {!allBranches &&
              <div className="mb-4">
                <SelectInput
                  label={Dict("select_branch")}
                  defaultValue={branchIds}
                  multiselect={true}
                  autoLoadService={getFieldBranches}
                  autoLoadRender={({field_title, title}) => {
                    return field_title + " - " + title
                  }}
                  onChange={setBranchIds}
                />
                {/*<Validator isChecked={isChecked} state={branchId} rules="num"/>*/}
              </div>
            }

            <Checkbox
              checked={allPersons}
              onChange={() => {
                if (!discount?.id) {
                  setAllPersons(!allPersons)
                } else {
                  Toaster.failure(null,
                    "امکان تغییر این گزینه وجود ندارد.")
                }
              }
              }
              label={
                <div>
                  <Typography color="blue-gray" className="font-medium">
                    همه کاربران
                  </Typography>
                  <Typography variant="small" color="gray" className="font-normal">
                    با غیرفعال کردن این گزینه، می‌توانید کاربران مورد نظر را محدود کنید.
                  </Typography>
                </div>
              }
              containerProps={{
                className: "-mt-5",
              }}

            />

            {!allPersons &&
              <div className="mb-4">
                <SelectInput
                  label={Dict("users")}
                  defaultValue={personIds}
                  multiselect={true}
                  autoLoadService={getPersonsNameAndFamily}
                  autoLoadRender={({name, family, phone}) => {
                    const fullName = `${name?.trim()} ${family?.trim()}`.trim();
                    return fullName + " - " + phone
                  }}
                  onChange={setPersonIds}
                />
                {/*<Validator isChecked={isChecked} state={branchId} rules="num"/>*/}
              </div>
            }

            <Checkbox
              checked={allAgents}
              onChange={() => {
                if (!discount?.id) {
                  setAllAgents(!allAgents)
                } else {
                  Toaster.failure(null,
                    "امکان تغییر این گزینه وجود ندارد.")
                }
              }
              }
              label={
                <div>
                  <Typography color="blue-gray" className="font-medium">
                    همه مشاوران
                  </Typography>
                  <Typography variant="small" color="gray" className="font-normal">
                    با غیرفعال کردن این گزینه، می‌توانید مشاوران مورد نظر را محدود کنید.
                  </Typography>
                </div>
              }
              containerProps={{
                className: "-mt-5",
              }}

            />

            {!allAgents &&
              <div className="mb-4">
                <SelectInput
                  label={Dict("agents")}
                  defaultValue={agentIds}
                  multiselect={true}
                  autoLoadService={getAgentsList}
                  autoLoadRender={({name, family, phone}) => {
                    const fullName = `${name?.trim()} ${family?.trim()}`.trim();
                    return fullName + " - " + phone
                  }}
                  onChange={setAgentIds}
                />
                {/*<Validator isChecked={isChecked} state={branchId} rules="num"/>*/}
              </div>
            }

            <div className="">
              <Switch
                label={
                  <Typography color="blue-gray" className="font-medium">
                    فعال/غیرفعال
                  </Typography>
                }
                checked={discount?.status}
                onChange={(e) => {
                  setStatus(e.target.checked)
                  setDiscount(discount => ({
                    ...discount,
                    status: e.target.checked,
                  }))
                }}
                labelProps={{className: "mx-4"}}
              />
            </div>
          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
            <Button variant="gradient" color="gray" className="ml-1" onClick={save}>
              <span>ذخیره</span>
            </Button>
          </DialogFooter>
        </Dialog>
      </>
    </ValidatorProvider>
  );
}